'use client';

import { forwardRef, InputHTMLAttributes, ReactNode, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './InputField.module.scss';
interface InputFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  icon?: ReactNode;
  type?: string;
  error?: string;
  showPasswordToggle?: boolean;
}
const InputField = forwardRef<HTMLInputElement, InputFieldProps>(({
  icon,
  type = 'text',
  error,
  showPasswordToggle = false,
  className,
  ...rest
}, ref) => {
  const [reveal, setReveal] = useState(false);
  const isPassword = type === 'password' && showPasswordToggle;
  const effectiveType = isPassword ? reveal ? 'text' : 'password' : type;
  return <div className={styles.field}>
                <div className={`${styles.wrap} ${error ? styles.invalid : ''}`.trim()}>
                    {icon && <span className={styles.icon} aria-hidden="true">
                            {icon}
                        </span>}
                    <input ref={ref} type={effectiveType} className={`${styles.input} ${!icon ? styles.inputNoIcon : ''} ${isPassword ? styles.inputWithTrailing : ''} ${className || ''}`.trim()} {...rest} />
                    {isPassword && <button type="button" className={styles.eyeBtn} onClick={() => setReveal(v => !v)} aria-label={reveal ? 'Hide password' : 'Show password'} tabIndex={-1}>
                            {reveal ? <EyeOff size={20} strokeWidth={2} /> : <Eye size={20} strokeWidth={2} />}
                        </button>}
                </div>
                {error && <p className={styles.error}>{error}</p>}
            </div>;
});
InputField.displayName = 'InputField';
export default InputField;